import React from "react";
import Header from "../../Components/Header/Header";
import NewsItems from "./NewsItems/NewsItems";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";

const News = () => {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumb title={t("Bloq")} />
 
      <NewsItems />
    </>
  );
};

export default News;
